import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

interface Props {
    children: React.ReactNode;
}

export const Finished: React.FC<Props> = ({ children }) => {
    const { t } = useTranslation();

    return (
        <div className="flex items-center justify-center w-full min-h-screen p-4">
            <div className="w-full max-w-[420px] p-4 mx-auto bg-grey-light">
                <h3 className="mb-4 text-3xl font-bold text-center text-blue">{t('PAGES.LOGIN')}</h3>
                <p className="text-center text-black">{children}</p>
                <Link
                    className="text-xs font-semibold bg-blue py-2 px-3.5 text-white flex justify-center"
                    to={'/login'}
                >
                    {t('LOGIN.LOGIN_BUTTON_TEXT')}
                </Link>
            </div>
        </div>
    );
};

export default Finished;
